/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { ADMIN_BEARER_NAME, ADMIN_ROUTES } from '../../util/vars';
import React from 'react';
import LoginPageComponent from './Login/LoginPageComponent';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useLocalStorage } from 'react-use';
import { SchoolListPageComponent } from './SchoolList/SchoolListPageComponent';
import { ImplementationPageComponent } from './Implementation/ImplementationPageComponent';

export default function Routes() {
  const { path } = useRouteMatch();
  const [ adminBearer ] = useLocalStorage<string | null>(ADMIN_BEARER_NAME, null, { raw: true });
  const isAuthed = adminBearer != null;

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID!}>
      <Switch>
        {/* Protected: Implementation */}
        <Route path={`${path}${ADMIN_ROUTES.school}/:schoolId${ADMIN_ROUTES.implementation.home}`}>
          {isAuthed ? (
            <ImplementationPageComponent />
          ) : (
            <Redirect to={`${path}${ADMIN_ROUTES.login}`} />
          )}
        </Route>

        {/* Protected: Schools */}
        <Route path={`${path}${ADMIN_ROUTES.schools}`}>
          {isAuthed ? (
            <SchoolListPageComponent />
          ) : (
            <Redirect to={`${path}${ADMIN_ROUTES.login}`} />
          )}
        </Route>

        {/* Catch-all: public login (or bounce to default when authed) */}
        <Route>
          {isAuthed ? (
            <Redirect to={`${path}${ADMIN_ROUTES.schools}`} />
          ) : (
            <LoginPageComponent />
          )}
        </Route>
      </Switch>
    </GoogleOAuthProvider>
  );
}
